var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"wrapper"}},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"hpanel"},[(_vm.pdf)?_c('div',{staticClass:"panel-body"},[_c('div',{staticClass:"embed-container"},[_c('embed',{attrs:{"src":_vm.pdf}})])]):_vm._e()])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-aadf2eba","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/timestampFiles/TimestampedFileCertification.vue
// module id = null
// module chunks = 